import React from "react";

function SubmarineQuestPrivacyPolicy() {
  return (
    <div style={{ padding: "2rem", backgroundColor: "#000", color: "#fff" }}>
      <h1>Privacy Policy for Submarine Quest</h1>
      <p><strong>Last Updated: 7th Jan 2025</strong></p>

      <p>
        Thank you for playing <strong>Submarine Quest</strong> (“the Game”)! 
        This Privacy Policy describes how we collect, use, and share personal 
        information when you play the Game and/or visit our website 
        (together, “the Services”).
      </p>

      <h2>1. Who We Are</h2>
      <p>
        We are KHAOLAM INTERACTIVE COMPANY LIMITED, the creators of Submarine Quest. If you 
        have any questions regarding this policy or our data practices, 
        please contact us at <strong>tech@khaolam.com</strong>.
      </p>

      <h2>2. Information We Collect</h2>
      <ul>
        <li>
          <strong>In-Game Data:</strong> We record your progress (levels, 
          achievements, in-app purchases) to provide gameplay continuity 
          and restore your status if you switch devices or reinstall the Game.
        </li>
        <li>
          <strong>Device Information:</strong> We collect unique device 
          identifiers (e.g., Android Advertising ID, iOS Identifier for 
          Advertisers) to help us diagnose crashes, prevent fraud, and 
          serve relevant ads.
        </li>
        <li>
          <strong>Analytics Data:</strong> We use Firebase Analytics and 
          Google Analytics to gather insights about how players engage 
          with the Game, such as session duration, interactions, approximate 
          location, and device details.
        </li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>
          <strong>Provide &amp; Improve the Game:</strong> Track in-game data, 
          user progress, and purchases to ensure a seamless experience.
        </li>
        <li>
          <strong>Analytics &amp; Performance:</strong> Understand usage trends 
          to improve gameplay, optimize user flow, and fix bugs.
        </li>
        <li>
          <strong>Advertising:</strong> Serve ads through third-party networks 
          and personalize them based on device and usage data where applicable.
        </li>
        <li>
          <strong>User Support:</strong> Respond to player inquiries, requests, 
          or technical issues.
        </li>
      </ul>

      <h2>4. Third-Party Services</h2>
      <ul>
        <li>
          <strong>Ad Providers:</strong> AdMob (by Google), Unity Ads. These 
          platforms help us serve advertisements and may collect device 
          information such as advertising identifiers, as well as track 
          ad performance.
        </li>
        <li>
          <strong>Analytics Platforms:</strong> Firebase Analytics (by Google), 
          Google Analytics. These services allow us to monitor usage patterns 
          and application performance.
        </li>
        <li>
          <strong>Authentication Services:</strong> Google Play 
          Center (Android), Apple Game Center (iOS). These services process 
          authentication data and store your progress to enable features like 
          leaderboards or multi-device play.
        </li>
      </ul>

      <h2>5. International Data</h2>
      <p>
        Our Services are <strong>global</strong>, so information you provide 
        may be transferred or stored in countries outside of your residence. 
        We strive to take measures to ensure adequate data protection, 
        but by using our Services, you acknowledge that your information 
        may be processed in other jurisdictions.
      </p>

      <h2>6. Data Sharing &amp; Disclosure</h2>
      <p>
        We share your data with the third-party services mentioned above 
        (e.g., AdMob, Unity Ads, Google Analytics, Firebase). Each provider 
        has its own privacy policy on how they collect and use data. 
        We do <strong>not</strong> sell your personal information to 
        third parties.
      </p>

      <h2>7. In-App Purchases</h2>
      <p>
        All in-app purchases are handled through <strong>Apple’s App Store</strong> or <strong>Google Play Store</strong>. We do <strong>not</strong> collect or store any payment or financial information directly. 
        Please refer to the payment processor’s terms for further information 
        on how they handle your data.
      </p>

      <h2>8. Data Retention</h2>
      <p>
        We retain your game progress and related data as long as your account 
        remains active or as needed to provide the Services. If you request account removal, we will delete or anonymize 
        your personal data.
      </p>

      <h2>9. Children’s Privacy</h2>
      <p>
        Submarine Quest is not specifically intended for children under 
        the age required by local regulations (e.g., 13 in the U.S.). 
        If you believe your child has provided personal data without your 
        consent, please contact us so we can remove that information.
      </p>

      <h2>10. Security</h2>
      <p>
        We take reasonable measures to protect your data from unauthorized 
        access, alteration, disclosure, or destruction. However, no online 
        service can guarantee absolute security.
      </p>

      <h2>11. Your Rights &amp; Choices</h2>
      <ul>
        <li>
          <strong>Opt-Out of Ads:</strong> Depending on your device, you can 
          reset or limit ad tracking through your operating system settings.
        </li>
        <li>
          <strong>Access &amp; Deletion:</strong> You can request access to 
          or deletion of your data by emailing us at 
          <strong>tech@khaolam.com</strong>.
        </li>
        <li>
          <strong>Account &amp; Game Data:</strong> If you use Google Play Center, 
          or Apple Game Center, you can manage permissions 
          within your device settings or respective account settings.
        </li>
      </ul>

      <h2>12. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes 
        will be posted on our website under <strong>/submarinequest-privacy</strong>, and 
        the “Last Updated” date will reflect when the changes become effective.
      </p>

      <h2>13. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, 
        please email us at <strong>tech@khaolam.com</strong>.
      </p>

      <p>
        <em>
          By playing Submarine Quest or using our website, you acknowledge 
          that you have read and understood this Privacy Policy.
        </em>
      </p>
    </div>
  );
}

export default SubmarineQuestPrivacyPolicy;